import React from "react";
import { type IntegrationSimple, type CaseStudySimple } from "lib/sanity";
import { Section, sectionSpacingY } from "components/section";
import { CenteredQuote } from "components/quotes";
import {
  SecurityFeatures,
  ComposableCdpAccordion,
  IndustryLeaderAwards,
  DestinationMarquee,
  CustomerStats,
} from "components/content";
import { AidAccordion, CaseStudySlider, ComposableCdpSlideshow, PlatformCards, UseCasesByTeam } from "components/home";
import { AuraPlate, SolidPlate } from "ui/plates";

type HomeTemplateProps = {
  destinations: IntegrationSimple[];
  caseStudies: CaseStudySimple[];
};

export function HomeTemplate({ destinations, caseStudies }: HomeTemplateProps) {
  const petsmart = caseStudies.find((c) => c.customer.slug === "petsmart")!;
  const wmg = caseStudies.find((c) => c.customer.slug === "wmg")!;
  const weightWatchers = caseStudies.find((c) => c.customer.slug === "weight-watchers")!;
  const chime = caseStudies.find((c) => c.customer.slug === "chime")!;
  const whoop = caseStudies.find((c) => c.customer.slug === "whoop")!;

  return (
    <>
      <PlatformCards />

      <CustomerStats customers={[wmg.customer, petsmart.customer, weightWatchers.customer]} />

      <CaseStudySlider wmg={wmg} petsmart={petsmart} weightWatchers={weightWatchers} chime={chime} whoop={whoop} />

      <SolidPlate
        bgColor="new.blue.950"
        spotlightColor="new.blue.900"
        theme="dark"
        maxW="100%"
        py={{ base: "bigger", md: "biggest" }}
        px={0}
      >
        <AidAccordion />

        <AuraPlate condensed theme="dark" variant="blue" my="biggest">
          <CenteredQuote
            theme="dark"
            maxW="800px"
            quoteText="With AI Decisioning, we saw a significant lift in our cross-sell campaigns within just 6 weeks. It’s transformed our team’s focus from manual tasks to high-impact strategic work"
            author={{ name: "Aoife O’Driscoll", job: "AVP Lifecycle Marketing" }}
            company={{ name: "Whoop", logo: whoop.customer.logoUrl }}
          />
        </AuraPlate>

        <ComposableCdpSlideshow />
      </SolidPlate>

      <Section my="0" pt={sectionSpacingY}>
        <ComposableCdpAccordion sectionTitle="Hightouch is an extension of your data warehouse" sectionMaxW="3xl" />
      </Section>

      <SecurityFeatures mt={{ base: "biggest", md: "huger" }} mb={{ base: "biggest", md: "huge" }} />

      <UseCasesByTeam />

      <IndustryLeaderAwards />

      <DestinationMarquee destinations={destinations} my={0} py={sectionSpacingY} />
    </>
  );
}
